module.exports = __webpack_public_path__ + "static/media/feature1.d29ee0c8.jpg";